import { render, staticRenderFns } from "./broadset.vue?vue&type=template&id=a8b1c6de"
import script from "./broadset.vue?vue&type=script&lang=js"
export * from "./broadset.vue?vue&type=script&lang=js"
import style0 from "./broadset.vue?vue&type=style&index=0&id=a8b1c6de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports